import setup from './moduleSetup';

export default {
    name: 'thirdPartLibraries',
    before: [],
    after: [],
    setup,
};
